<template>
  <div>
    <admin-left-navigation />

    <!-- Mobile Header -->
    <div v-if="$vuetify.breakpoint.mdAndDown">
      <div class="mobile-menu">
        <div
          class="d-flex justify-space-between align-center"
          color="primary"
        >
          <div
            class="py-5 px-8" width="120"
            @click="$store.commit('setNavVisible', true)"
            style="cursor: pointer;"
          >
            <v-icon
              fab
              color="white"
            >
              fa-solid fa-bars
            </v-icon>
          </div>
          <div class="pa-5 center">
            <router-link to="/admin" class="d-inline-flex">
              <img src="@/assets/logos/cdseo-logo-white.png" class="logo" width="180" height="45" alt="Admin Dashboard" />
            </router-link>
          </div>
          <div class="py-5 px-8">
            <!-- Placeholder for symmetry -->
          </div>
        </div>
      </div>
    </div>

    <v-main
      :style="$vuetify.breakpoint.mdAndDown ? { height: 'calc(100% - 92px)' } : {}"
    >
      <div
        :class="[
          $vuetify.breakpoint.xs ? 'pt-6 pa-2' : '',
          $vuetify.breakpoint.sm ? 'pa-4' : '',
          $vuetify.breakpoint.md ? 'pa-6' : '',
          $vuetify.breakpoint.lgAndUp ? 'pa-10' : ''
        ]"
        style="height: 100%"
      >
        <router-view />
      </div>
    </v-main>
  </div>
</template>

<script>
import AdminLeftNavigation from '@/components/Admin/AdminLeftNavigation.vue'

export default {
  name: 'AdminLayout',
  components: {
    AdminLeftNavigation
  }
}
</script>

<style scoped>
.mobile-menu {
  background-color: #1A5984;
  position: sticky;
  top: 0;
  z-index: 10;
}
.theme--dark .mobile-menu {
  background-color: #0a3855;
}
.logo {
  display: block;
}
</style>
